// extracted by mini-css-extract-plugin
export default {"root":"ResponsiveTitleCell-root_uG_5t","title":"ResponsiveTitleCell-title_V8Ao3"};